var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-dark btn-lg btn-block",attrs:{"type":"submit"},on:{"click":function($event){return _vm.logOut()}}},[_vm._v(" 登出 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }